export * from './src/clip.height';